import styled from 'styled-components';

const RegularText = styled.div`
  color: var(--grey500);
  font-size: 12px;
`;
export default RegularText;
